import NavBar from "./Components/NavBar";
import "./CSS/reporte.css";
import React, { useState, useEffect } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import {
  collection,
  getDocs,
  query,
  where,
  deleteDoc,
  doc,
  orderBy,
} from "firebase/firestore";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { db } from "./FirebaseConfig/firebase";
import Button from "@mui/material/Button";

import { CSVLink } from "react-csv";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import { utils } from "xlsx";

const MySwal = withReactContent(Swal);
function Reporte() {
  const navigate = useNavigate();
  const { id } = useParams();

  const [codigosList, setCodigosList] = useState([]);
  const [codIngeniero, setCodIngeniero] = useState();
  const [datosCargados, setDatosCargados] = useState(false); // MOSTRAR BARRA DE CARGA
  const [showMore, setShowMore] = useState(false);

  function createData(name, calories, fat, carbs, protein) {
    return { name, calories, fat, carbs, protein };
  }

  //FOR DE FORS
  const buscarCodigos = async () => {
    const cuponesList = collection(db, `EVENTOS/${id}/AsientosRegistrados`);
    const q = query(cuponesList, orderBy("fecha", "desc"));
    const data = await getDocs(q);
    setCodigosList(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
    setDatosCargados(true);
  };
  const toggleShowMore = () => {
    setShowMore(!showMore);
  };
  //cerrar cupones
  const cerrar = () => {
    navigate(`../eventos/${id}/registrarParticipante`);
  };

  const buscarIdUsuario = async (idTicket, CIPingeniero, listAsientos) => {
    Swal.fire({
      title: "Eliminar reserva?",
      text: "El usuario ya no podra ver su entrada",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, eliminar!",
      cancelButtonText: "No, cancelar!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const q = query(
          collection(db, "USUARIOS"),
          where("cip", "==", CIPingeniero)
        );
        const querySnapshot = await getDocs(q);
        console.log(CIPingeniero);
        querySnapshot.forEach((doc) => {
          console.log(idTicket);

          borrarTicketUsuario(doc.id, listAsientos, idTicket);
        });
        Swal.fire({
          title: "Eliminado!",
          text: "La reserva ha sido eliminada",
          icon: "success",
        });
        buscarCodigos();
      } else if (
        /* Read more about handling dismissals below */
        result.dismiss === Swal.DismissReason.cancel
      ) {
        console.log("NO");
        Swal.fire({
          title: "Cancelado!",
          text: "La entrada no se elimino :)",
          icon: "warning",
        });
      }
    });
  };
  const borrarTicketUsuario = async (idUsuario, listAsientos, idTicket) => {
    const q = query(
      collection(db, `USUARIOS/${idUsuario}/AsientosRegistrados`),
      where("asientos", "==", listAsientos)
    );
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach(async (docume) => {
      console.log(docume.id);
      const usuario = doc(
        db,
        `USUARIOS/${idUsuario}/AsientosRegistrados`,
        docume.id
      );
      await deleteDoc(usuario);
      await deleteDoc(doc(db, `EVENTOS/${id}/AsientosRegistrados`, idTicket));
      buscarCodigos();
    });
  };
  const descargarTabla = () => {
    // Encabezado completo con los nuevos campos
    const header = [
      "CIP",
      "APELLIDOS",
      "NOMBRES",
      "ASIENTOS COMPRADOS",
      "ESTADO DE PAGO",
      "FECHA DE COMPRA",
      "INVITADO",
      "ASIENTO INVITADO",
    ];

    // Construir las filas dinámicamente
    const dataWithHeader = [
      header,
      ...codigosList.flatMap((item) => {
        // Si no hay invitados, crea una fila vacía para esos campos
        console.log(item.invitados.length);
        if (item.invitados.length === 0) {
          return [
            [
              item.CIP,
              item.apellidos,
              item.nombre,
              item.asientos,
              item.estado,
              item.fecha,
              "", // invitado vacío
              "", // asiento invitado vacío
            ],
          ];
        } else {
          console.log("CAVEZA");

          // Si hay invitados, genera una fila por cada invitado
          return item.invitados.map((inv) => [
            item.CIP,
            item.apellidos,
            item.nombre,
            item.asientos,
            item.estado,
            item.fecha,
            inv.nombre,
            inv.asiento,
          ]);
        }
      }),
    ];

    exportToXlsx(dataWithHeader);
  };

  function exportToXlsx(data) {
    // ✅ Crear la hoja a partir de un array de arrays (AOA)
    // Esto es mejor que json_to_sheet cuando el primer elemento es el encabezado
    const worksheet = XLSX.utils.aoa_to_sheet(data);

    // ✅ Configurar anchos de columna (ajústalos según lo que necesites)
    worksheet["!cols"] = [
      { wch: 10 }, // CIP
      { wch: 20 }, // APELLIDOS
      { wch: 20 }, // NOMBRES
      { wch: 25 }, // ASIENTOS COMPRADOS
      { wch: 20 }, // ESTADO DE PAGO
      { wch: 30 }, // FECHA DE COMPRA
      { wch: 25 }, // INVITADO
      { wch: 20 }, // ASIENTO INVITADO
    ];

    // ✅ Crear libro y añadir hoja
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Reporte");

    // ✅ Escribir archivo binario
    const file = XLSX.write(workbook, { bookType: "xlsx", type: "binary" });

    // ✅ Convertir a Blob para descarga
    const blob = new Blob([s2ab(file)], { type: "application/octet-stream" });

    // ✅ Crear enlace de descarga automático
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "Reporte_Asientos.xlsx";
    link.click();

    // ✅ Limpieza opcional (borrar URL temporal)
    setTimeout(() => URL.revokeObjectURL(link.href), 1000);
  }

  // Función auxiliar para convertir string binario → ArrayBuffer
  function s2ab(s) {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i !== s.length; ++i) {
      view[i] = s.charCodeAt(i) & 0xff;
    }
    return buf;
  }
  window._fetchBlob = function (url, fileExtension) {
    var xhr = new XMLHttpRequest();
    xhr.open("GET", url);
    xhr.responseType = "blob";

    xhr.onload = function () {
      if (xhr.status === 200) {
        var reader = new FileReader();
        reader.onloadend = function () {
          var base64data = reader.result;
          window.android.onBlobData(base64data); // Llamar a la función `onBlobData()` en Android para devolver los datos
        };
        reader.readAsDataURL(xhr.response);
      } else {
        console.error("Error al descargar el archivo Blob.");
      }
    };

    xhr.send();
  };
  function s2ab(s) {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
    return buf;
  }
  const headers = [
    { label: "CIP", key: "CIP" },
    { label: "APELLIDOS", key: "apellidos" },
    { label: "NOMBRES", key: "nombre" },
    { label: "ASIENTOS", key: "asientos" },
    { label: "PAGO", key: "estado" },
    { label: "FECHA", key: "fecha" },
    { label: "PAGO", key: "estado" },
    { label: "FECHA", key: "fecha" },
  ];

  //const header = ["CIP", "APELLIDOS", "NOMBRES", "ASIENTOS", "PAGO", "FECHA"];

  useEffect(() => {
    if (codIngeniero) {
      //console.log("Buenos dias estrellitas");
    } else {
    }
  }, [codIngeniero]);

  useEffect(() => {
    buscarCodigos();
    console.log(codigosList);
  }, []);

  if (!datosCargados) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          margin: "0px auto",
          textAlign: "center",
          height: "100vh",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ verticalAlign: "middle", display: "block" }}>
          <div>
            <img
              style={{ height: "300px" }}
              src={require(`./img/docucargando.gif`)}
              alt="esperando"
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="panel">
      <NavBar
        titulo="REPORTES"
        nombre=""
        imagen="cerrar"
        logoTitulo="cupon"
        cerrar={cerrar}
      ></NavBar>
      <div className="reporte-cabecera">
        <h1 className="cd">Ingenieros registrados : {codigosList.length}</h1>
      </div>
      <div style={{ paddingLeft: "50px" }}>
        <Button
          variant="contained"
          color="success"
          onClick={() => {
            descargarTabla();
          }}
        >
          DESCARGAR REPORTE
        </Button>
      </div>

      <div className="reporte-tabla">
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
            <TableHead>
              <TableRow>
                <TableCell align="center">
                  <b>CODIGO CIP USUARIO</b>
                </TableCell>
                <TableCell align="center">
                  <b>APELLIDOS</b>
                </TableCell>
                <TableCell align="center">
                  <b>NOMBRES</b>
                </TableCell>
                <TableCell align="center">
                  <b>ASIENTOS COMPRADOS</b>
                </TableCell>
                {codigosList.some(
                  (item) => item.invitados && item.invitados.length > 0
                ) && (
                  <TableCell align="center">
                    <b>INVITADOS</b>
                  </TableCell>
                )}
                <TableCell align="center">
                  <b>ESTADO DE PAGO</b>
                </TableCell>
                <TableCell align="center">
                  <b>FECHA DE COMPRA</b>
                </TableCell>
                <TableCell align="center">
                  <b>TICKET</b>
                </TableCell>
                <TableCell align="center">
                  <b>BORRAR</b>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {codigosList.map((row) => (
                <TableRow
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell align="center">{row.CIP}</TableCell>
                  <TableCell align="center">{row.apellidos}</TableCell>
                  <TableCell align="center">{row.nombre}</TableCell>

                  <TableCell style={{ width: "3px" }} align="center">
                    {showMore ? row.asientos : row.asientos.slice(0, 20)}
                    {row.asientos.length > 20 ? (
                      <button onClick={toggleShowMore} className="text-button">
                        {showMore ? "Ver menos" : "Ver más ... "}
                      </button>
                    ) : null}
                  </TableCell>
                  {codigosList.some(
                    (item) => item.invitados && item.invitados.length > 0
                  ) && (
                    <TableCell
                      align="center"
                      style={{ whiteSpace: "pre-line" }}
                    >
                      {row.invitados && row.invitados.length > 0
                        ? row.invitados
                            .map((inv) => `${inv.nombre} - ${inv.asiento}`)
                            .join("\n")
                        : ""}
                    </TableCell>
                  )}

                  <TableCell align="center">{row.estado}</TableCell>
                  <TableCell align="center">{row.fecha}</TableCell>
                  <TableCell align="center">
                    <Button
                      variant="contained"
                      color="success"
                      onClick={() => {
                        navigate(
                          `/eventos/${id}/registrarParticipante/${row.id}`
                        );
                      }}
                    >
                      Ver Entrada
                    </Button>
                  </TableCell>
                  <TableCell align="center">
                    <Button
                      variant="contained"
                      color="error"
                      onClick={() => {
                        //borrarTicket(row.id);
                        buscarIdUsuario(row.id, row.CIP, row.asientos);
                        //borrarTicketUsuario(row.asientos)
                      }}
                    >
                      BORRAR
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
}

export default Reporte;
